import { PipelineDetailsDto } from "@cradua/data";
import { environment } from "apps/epims/mrsoftepims/src/environments/environment";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class PipelinedetailsService {
  url = `${environment.apiUrl}pipelinedetails`;
  constructor(private http: HttpClient) {}

  getPipelinedetails(): Observable<PipelineDetailsDto[]> {
    return this.http.get<PipelineDetailsDto[]>(this.url);
  }

  createPipelinedetails(data: PipelineDetailsDto): Observable<PipelineDetailsDto> {
    return this.http.post<PipelineDetailsDto>(this.url, data);
  }
  getSinglePipelinedetails(id: string): Observable<any> {
    return this.http.get(this.url + "/" + id);
  }

  fetchPipelinedetails(query: any): Observable<PipelineDetailsDto[]> {
    return this.http.post<PipelineDetailsDto[]>(this.url + "/fetch", query);
  }

  fetchByIdPipelinedetails(id: any): Observable<PipelineDetailsDto[]> {
    return this.http.post<PipelineDetailsDto[]>(this.url + "/fetchById", {id});
  }

  updatePipelinedetails(data: PipelineDetailsDto): Observable<PipelineDetailsDto> {
    return this.http.post<PipelineDetailsDto>(this.url + "/update", data);
  }

  deletePipelinedetails(id: string) {
    return this.http.delete(this.url + "/" + id);
  }
}